import { useMemo } from 'react';
import { useAdminConfig } from './useAdminConfig';
import type { AdminPermission } from '../config/admin-permissions';

export function useAdminPermissions() {
  const { config, loading, error } = useAdminConfig();

  const permissionSet = useMemo(() => new Set(config?.permissions ?? []), [config?.permissions]);
  const hasPermission = (permission: AdminPermission): boolean => permissionSet.has(permission);
  const hasAnyPermission = (permissions: AdminPermission[]): boolean => permissions.some((permission) => permissionSet.has(permission));

  return {
    loading,
    error,
    permissions: config?.permissions ?? [],
    hasPermission,
    hasAnyPermission,
  };
}
